import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'shabic-icon-delete',
  templateUrl: './icon-delete.component.html',
  styleUrls: ['./icon-delete.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconDeleteComponent {}
